module.exports = __webpack_public_path__ + "media/img/super-venue/icons/filter-6cc9d270e62fb9ea43c66716e7de6de7.svg";